import CorePermissions from '#layers/core/shared/permissions';

export default class Permissions extends CorePermissions
{
    public static Cms = class
    {
        public static Pages = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Cms.PagesPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Cms.PagesPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Cms.PagesPermissions@Delete';
        };

        public static Layouts = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Cms.LayoutsPermissions@View';
            public static Compose = 'Ideo.Core.Edito.Application.Permissions.Cms.LayoutsPermissions@Compose';
            public static Publish = 'Ideo.Core.Edito.Application.Permissions.Cms.LayoutsPermissions@Publish';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Cms.LayoutsPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Cms.LayoutsPermissions@Delete';
        };

        public static Websites = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Cms.WebsitesPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Cms.WebsitesPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Cms.WebsitesPermissions@Delete';
        };

        public static Articles = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@Delete';
            public static Accept = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@Accept';
            public static Publish = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@Publish';
            public static EditAll = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@EditAll';
            public static DeleteAll = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@DeleteAll';
            public static AcceptAll = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@AcceptAll';
            public static PublishAll = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@PublishAll';
            public static CategoryCreate = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesPermissions@CategoryCreate';
        };

        public static ArticleLabels = class
        {
            public static View = 'Ideo.Core.Application.Edito.Permissions.Modules.ArticleLabelsPermissions@View';
            public static Edit = 'Ideo.Core.Application.Edito.Permissions.Modules.ArticleLabelsPermissions@Edit';
            public static Delete = 'Ideo.Core.Application.Edito.Permissions.Modules.ArticleLabelsPermissions@Delete';
        };

        public static ArticlesCategories = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesCategoriesPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.ArticlesCategoriesPermissions@Edit';
        };

        public static Informations = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@Delete';
            public static Accept = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@Accept';
            public static Publish = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@Publish';
            public static EditAll = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@EditAll';
            public static DeleteAll = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@DeleteAll';
            public static AcceptAll = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@AcceptAll';
            public static PublishAll = 'Ideo.Core.Edito.Application.Permissions.Modules.InformationsPermissions@PublishAll';
        };

        public static Faq = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@Delete';
            public static Accept = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@Accept';
            public static Publish = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@Publish';
            public static EditAll = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@EditAll';
            public static DeleteAll = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@DeleteAll';
            public static AcceptAll = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@AcceptAll';
            public static PublishAll = 'Ideo.Core.Edito.Application.Permissions.Modules.FaqPermissions@PublishAll';
        };

        public static Tags = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.TagsPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.TagsPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Modules.TagsPermissions@Delete';
            public static Publish = 'Ideo.Core.Edito.Application.Permissions.Modules.TagsPermissions@Publish';
        };

        public static Comments = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.CommentsPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.CommentsPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Modules.CommentsPermissions@Delete';
            public static Accept = 'Ideo.Core.Edito.Application.Permissions.Modules.CommentsPermissions@Accept';
        };

        public static CommentsSets = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Modules.CommentsSetsPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Modules.CommentsSetsPermissions@Edit';
        };
    };

    public static Premium = class
    {
        public static Packages = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Premium.PackagesPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Premium.PackagesPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Premium.PackagesPermissions@Delete';
        };

        public static Settings = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Premium.SettingsPermissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Premium.SettingsPermissions@Edit';
            public static Delete = 'Ideo.Core.Edito.Application.Permissions.Premium.SettingsPermissions@Delete';
        };

        public static Customers = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Premium.CustomersPermissions@View';
        };

        public static Orders = class
        {
            public static View = 'Ideo.Core.Edito.Application.Permissions.Premium.OrdersPremissions@View';
            public static Edit = 'Ideo.Core.Edito.Application.Permissions.Premium.OrdersPremissions@Edit';
        };
    };
}
